import { decryptPassword } from '@/Utils/cryptoUtils';
import { fetchBannedToServer } from '@/api/member';
import store from '@/store';
import { p2pActions } from '@/store/p2p-slice';
import {
    getMembersData,
    updatePrivateKey,
} from '@/store/server-data-reducer/server-data-reducer';

import { onJoinChannel } from '../ChannelActions/channelActions';
import { fetchP2PWhiteList } from '../p2p-connection/p2pApis';
import { sendP2PSocketData } from '../p2p-connection/p2pConnection';

export const handleAuthSuccess = async ({
    activeServer,
    privateKey,
    serverData,
    publicKey,
    activeChannel,
}: {
    activeServer: string;
    privateKey: string;
    serverData: any;
    publicKey: string;
    activeChannel: string;
}) => {
    setTimeout(() => {
        if (store.getState().p2pReducer.availableCondition) {
            sendP2PSocketData({
                command: 'setavailable',
                data: [],
            });
        } else {
            store.dispatch(p2pActions.setAvailableCondition(true));
        }
    }, 2000);

    try {
        const { response } = await fetchP2PWhiteList();
        store.dispatch(p2pActions.updatePermittedList(response));
    } catch (err) {
        console.error(err);
    }

    try {
        await store.dispatch(getMembersData(activeServer));
        await store.dispatch(fetchBannedToServer(activeServer));

        if (!serverData.defaultHashkey) {
            const privateKeyObject = decryptPassword(privateKey);
            const hashKey = CryptoJS.MD5(
                JSON.stringify(privateKeyObject),
            ).toString();
            store.dispatch(
                updatePrivateKey({
                    id: activeServer,
                    defaultHashkey: hashKey,
                    privateKey,
                    publicKey,
                }),
            );
        }
        if (activeChannel) onJoinChannel(activeChannel);
    } catch (error) {
        console.error('Error in handleAuthSuccess:', error);
    }
};
